'use client';
import styled from 'styled-components';
import { colors, toRgba, breakPoints } from '@/styles';

export const EvaluationCard = styled.div`
  display: flex;
  border: 1px solid ${colors.secondary.lightGray3} !important;
  border-radius: 5px;
  background: ${colors.primary.white};
  box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.1);

  & > * {
    display: flex;
    overflow: hidden;
    flex-grow: 1;
  }
`;

export const EvaluationBody = styled.div`
  display: flex;
  flex-direction: column;

  & > * {
    padding: 10px 20px;
    &:last-child {
      border-bottom: none;
    }
  }
`;

export const EvaluationHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EvaluationHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  & > * {
    flex-grow: 1;
    min-width: 0;
  }
`;

export const EvaluationTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex-grow: 1;
`;

export const StatusStack = styled.div`
  min-width: 160px;
  flex: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0px;
  border-bottom: none;
  border-left: 1px solid ${colors.secondary.lightGray3};
  background-color: ${colors.secondary.lightGray1};
  font-family: monospace;
  & > * {
    border-bottom: 1px solid ${colors.secondary.lightGray3};
    padding: 2px 10px;
    flex-grow: 1;
    &:last-child {
      border-bottom: none;
    }
  }
  @media (max-width: ${breakPoints.mobilePortrait}) {
    flex-wrap: wrap;
  }
`;

export const Delete = styled.div`
  display: flex;
  width: 24px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 2px;
  border-radius: 2px;
  /* background-color: ${colors.secondary.lightGray3}; */
  &:hover {
    background-color: ${colors.semantic.negative.light};
  }
  color: ${colors.semantic.negative.dark};
`;

export const PromptSection = styled.div`
  display: flex;
  flex-direction: column;

  label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
  }
`;

export const Prompt = styled.div<{ $lines: number }>`
  position: relative;
  background-color: ${colors.secondary.lightGray1};
  border-radius: 5px;
  border: 1px solid ${colors.secondary.lightGray3};
  padding: 5px 20px 15px 20px;
  font-family: monospace;
  /* interpolate-size: allow-keywords; */

  & > pre {
    margin: 0;
    overflow: hidden;
    line-height: 1.25;
    border-radius: 5px;
    /* display: -webkit-box; */
    height: ${({ $lines }) => $lines}lh;
    overflow: auto;
  }

  &:after {
    display: block;
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      ${toRgba(colors.secondary.lightGray1, 0)},
      ${toRgba(colors.secondary.lightGray1, 1)} 75%
    );

    width: 100%;
    height: 50px;
  }
`;
